import { Option } from "../../components/options/types";

export const FINANCE_ROUTES_OPTIONS: Array<Option<string>> = [
  {
    title: "ثبت چک جدید",
    value: "/financial",
  },
  {
    title: "ثبت نقدی",
    value: "/financial/cash",
  },
  {
    title: "فروش چک",
    value: "/financial/spend-factor",
  },
];
